import { Companion_getInstance1tv6fqjnytc8u as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpinMutationSelectionsClass;
function SpinMutationSelections() {
  if (SpinMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        SpinMutationSelections_instance = this;
        this.__root_1 = listOf((new (Builder())('spin', Companion_getInstance().type_1)).arguments_2si9qu_k$(listOf((new (Builder_0())(Companion_getInstance_0().__spin_input_1)).value_oig1rm_k$(new (CompiledVariable())('input')).build_1k0s4u_k$())).build_1k0s4u_k$());
      }
    }
    initMetadataForObject($, 'SpinMutationSelections');
    SpinMutationSelectionsClass = $;
  }
  return SpinMutationSelectionsClass;
}
var SpinMutationSelections_instance;
function SpinMutationSelections_getInstance() {
  if (SpinMutationSelections_instance === VOID)
    new (SpinMutationSelections())();
  return SpinMutationSelections_instance;
}
//region block: exports
export {
  SpinMutationSelections_getInstance as SpinMutationSelections_getInstance3ie83td9rt26x,
};
//endregion

//# sourceMappingURL=SpinMutationSelections.mjs.map
